import Image from './ImageFactory';

export default Image;
